import React, { PureComponent } from 'react';
import autobind from 'autobind-decorator';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import HvSvg from 'src/components/HvSvg';
import appDux from 'src/redux/app';
import uiDux from 'src/redux/ui';

import { ExtendedSidebarContainer, CloseAllSidebarsButton } from './styled';

const mapStateToProps = (state) => ({
  isOpen: state.designPro.ui.isExtendedSidebarOpen,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeExtendedSidebar: uiDux.actions.closeExtendedSidebar,
      handleSidebarCloseClick: uiDux.actions.handleSidebarCloseClick,
    },
    dispatch,
  );

export class ExtendedSidebar extends PureComponent {
  static propTypes = {
    category: PropTypes.string,
    closeExtendedSidebar: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    render: PropTypes.func.isRequired,
    shouldIgnoreOutsideClicks: PropTypes.bool.isRequired,
    handleSidebarCloseClick: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.sidebarEl = document.getElementById('sidebar-root');
    document.addEventListener('click', this.handleDocumentClick);
  }

  componentDidUpdate(prevProps) {
    const { category, isOpen } = this.props;
    const categoryChanged = category !== prevProps.category;

    if (isOpen && categoryChanged) {
      this.container.scrollTop = 0;
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
  }

  @autobind
  handleDocumentClick(event) {
    const { shouldIgnoreOutsideClicks, closeExtendedSidebar } = this.props;
    // component user opted out of close on outside click
    if (shouldIgnoreOutsideClicks) return;
    // if event.target is not in the DOM, don't take action. This is needed
    // to avoid closing when content is no longer in sidebar due to rerender
    if (!document.contains(event.target)) return;

    // Close extended sidebar on clicks originating outside the sidebar/ext sidebar
    if (!this.sidebarEl.contains(event.target)) {
      const isWhitelisted = event.target.getAttribute(
        'data-ext-sidebar-click-whitelist',
      );
      if (!isWhitelisted) closeExtendedSidebar();
    }
  }

  render() {
    const {
      isOpen,
      render,
      closeExtendedSidebar,
      handleSidebarCloseClick,
    } = this.props;
    const Container = ExtendedSidebarContainer;

    if (!isOpen) return null;
    return (
      <>
        <Container
          data-selenium="extendedSidebar"
          innerRef={(c) => {
            /*
             * Why are we still using innerRef to create refs?
             * Because styled-components (below v4.0.0) requires using the innerRef prop.
             * https://www.styled-components.com/docs/api#deprecated-innerref-prop
             */
            this.container = c;
          }}
        >
          {render({ closeExtendedSidebar })}
        </Container>
        <CloseAllSidebarsButton
          onClick={handleSidebarCloseClick}
          data-selenium="closeAllSidebarsButton"
        >
          <HvSvg
            src={require('src/assets/images/small-triangle.svg')}
            disabled={false}
          />
        </CloseAllSidebarsButton>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExtendedSidebar);
